const generateLocationObject = (location) => ({
  latitude: location?.lat || 0,
  longitude: location?.lng || 0,
});

export default generateLocationObject;
